<template lang="pug">
page(
    main-title="Настройка виджета",
    main-description="Здесь Вы можете настроить внешний вид виджета",
    
)
    .panel
        .panel-body
            .row
                .col-md-8
                    .row
                        .col-md-12
                            .radio.clip-radio.radio-primary.radio-inline
                                input#long_list(type="radio", 
                                                v-model="settings.kind", 
                                                value="long")
                                label(for="long_list") Длинный список
                            .radio.clip-radio.radio-primary.radio-inline
                                input#short_list(type="radio", 
                                                 v-model="settings.kind", 
                                                 value="short")
                                label(for="short_list") Краткий список
                    hr
                    template(v-if="settings.kind === 'long'")
                        .row
                            .col-md-3
                                .radio(style="padding-left: 0!important;")
                                    span(style="font-size: 13px; position: relative; margin-bottom: 6px; line-height: 23px;")  Сортировка:
                            .col-md-9
                              .form-group
                                .radio.clip-radio.radio-primary
                                    input#sort_days(type="radio", 
                                                          v-model="settings.sort", 
                                                          value="days")
                                    label(for="sort_days") Сначала меньший срок доставки
                                .radio.clip-radio.radio-primary
                                    input#sort_price(type="radio", 
                                                     v-model="settings.sort", 
                                                     value="price")
                                    label(for="sort_price") Сначала меньшая стоимость доставки
                                .radio.clip-radio.radio-primary
                                    input#sort_mix(type="radio", 
                                                   v-model="settings.sort", 
                                                   value="mix")
                                    label(for="sort_mix") По совокупности срока и стоимости
                                .radio.clip-radio.radio-primary
                                    input#sort_custom(type="radio", 
                                                     v-model="settings.sort", 
                                                     value="custom")
                                    label(for="sort_custom") Собственная 
                                        | (задается&nbsp;в&nbsp;настройках&nbsp;служб&nbsp;доставки)
                        .row
                            .col-md-12                               
                                .checkbox.clip-check.check-primary
                                    input#divide_by_delivery_type(type="checkbox", v-model="settings.divide_by_delivery_type")
                                    label(for="divide_by_delivery_type") Разбивать по типу доставки (курьер/самовывоз)
                        .row
                            .col-md-12                              
                                .checkbox.clip-check.check-primary
                                    input#delivery_name_shown(type="checkbox", v-model="settings.delivery_name_shown")
                                    label(for="delivery_name_shown") Показывать названия служб доставки
                    template(v-else-if="settings.kind === 'short'")
                        .row
                            .col-md-3
                                .radio(style="padding-left: 0!important;")
                                    span(style="font-size: 13px; position: relative; margin-bottom: 6px; line-height: 23px;")  Показывать:
                            .col-md-9
                              .form-group
                                .radio.clip-radio.radio-primary
                                    input#only_min_shown(type="radio", 
                                                         v-model="settings.interval_type", 
                                                         value="min")
                                    label(for="only_min_shown") Только минимальное значение
                                .radio.clip-radio.radio-primary
                                    input#only_max_shown(type="radio", 
                                                         v-model="settings.interval_type", 
                                                         value="max")
                                    label(for="only_max_shown") Только максимальное значение
                                .radio.clip-radio.radio-primary
                                    input#max_and_min_shown(type="radio", 
                                                            v-model="settings.interval_type", 
                                                            value="all")
                                    label(for="max_and_min_shown") И максимальное и минимальное
                    .row
                        .col-md-12                              
                            .checkbox.clip-check.check-primary
                                input#delivery_price_shown(type="checkbox", v-model="settings.delivery_price_shown")
                                label(for="delivery_price_shown") Показывать стоимость доставки
                    .row
                        .col-md-12
                            .radio.clip-radio.radio-primary.radio-inline.radio-inline-margins
                                input#days_first(type="radio", 
                                                 v-model="settings.days_first", 
                                                 :value="true")
                                label(for="days_first") Сначала срок
                            .radio.clip-radio.radio-primary.radio-inline.radio-inline-margins
                                input#cost_first(type="radio", 
                                                 v-model="settings.days_first", 
                                                 :value="false")
                                label(for="cost_first") Сначала стоимость
                    .row
                        .col-md-12
                            .checkbox.clip-check.check-primary
                                input#with_city_choice(type="checkbox", 
                                                       v-model="settings.with_city_choice")
                                label(for="with_city_choice") Выбор города
                    .row
                        .col-md-12
                            .checkbox.clip-check.check-primary
                                input#pvz_map_shown(type="checkbox", v-model="settings.pvz_map_shown")
                                label(for="pvz_map_shown") Просмотр карт с пунктами самовывоза
                    .row
                        .col-md-12
                            .checkbox.clip-check.check-primary
                                input#widget_enabled(type="checkbox", v-model="settings.widget_enabled")
                                label(for="widget_enabled") Виджет включен
                    .row
                        .col-md-12
                            .checkbox.clip-check.check-primary
                                input#with_promo_code_in_cart(type="checkbox", v-model="settings.with_promo_code_in_cart")
                                label(for="with_promo_code_in_cart") Давать возможность использования промокода на доставку 
                                    | (в виджете в корзине)
                    .row
                        .col-md-12
                            a.btn.btn-transparent.btn-sm(
                                style="padding-left: 0;", 
                                @click.prevent="advancedSettingsShown = !advancedSettingsShown"
                            )
                                i.ti-minus(v-if="advancedSettingsShown")
                                i.ti-plus(v-if="!advancedSettingsShown")
                            | Расширенные настройки
                    .row(v-if="advancedSettingsShown")

                        .col-md-12.margin-top-10
                            p Для настройки внешнего вида виджета можно задать CSS-стили 
                                | (стили добавятся к Вашему сайту):
                            .form-group
                                .vfl-field.input-group(style='width: 100%;')
                                    <prism-editor v-model="settings.css_styles" language="css"></prism-editor> 
                                    span.field-underline
                                    label Редактируйте CSS-стили
                            .margin-bottom-10
                                a(href='#', @click.prevent="setDefaultStyles") Сбросить стили до начального значения

                        .col-md-12.margin-top-10
                            p Вы можете написать здесь опциональный JavaScript код, который будет выполнен на вашем сайте
                                | (в товарном и корзинном виджетах):
                            .form-group
                                .vfl-field.input-group(style='width: 100%;')
                                    <prism-editor v-model="settings.js" language="js"></prism-editor> 
                                    span.field-underline
                                    label Редактируйте JavaScript

                    .row
                        .col-md-12.margin-top-10(v-if="settingsChanged")
                            button.btn.btn-o.btn-primary(@click.prevent="save") Сохранить
                            button.btn.btn-o.btn-primary.pull-right(@click.prevent="discard") Отмена
                .col-md-4.reset-styles.padding-top-10
                    template(v-if="settings.kind === 'long'") 
                        p(v-if="settings.with_city_choice") Доставка в 
                            a(href="#", @click.prevent='', title='Липецкая обл') г. Липецк
                            | :
                        template(v-if="settings.divide_by_delivery_type")
                            p(v-if="deliveriesCourier.length") 
                                | Курьером:
                            ul(v-if="deliveriesCourier.length") 
                                li(v-for="item in deliveriesCourier")
                                    | {{ getDeliveryDescription(item) }}
                            p(v-if="deliveriesPvz.length") 
                                | Cамовывоз:
                            ul(v-if="deliveriesPvz.length") 
                                li(v-for="item in deliveriesPvz")
                                    | {{ getDeliveryDescription(item) }}
                        template(v-else)
                            ul
                                li(v-for="item in deliveriesSorted")
                                    | {{ getDeliveryDescription(item) }}
                        p(v-if="settings.pvz_map_shown") Просмотр  
                            a(href="#", @click.prevent='') пунктов самовывоза
                    template(v-else-if="settings.kind === 'short'")
                        p Доставка в 
                            a(v-if="settings.with_city_choice", 
                              href="#", 
                              @click.prevent='', 
                              title='Владимирская обл') г Владимир
                            span(v-if="!settings.with_city_choice")
                                | г Владимир
                            | : 
                            span(v-if="deliveriesCourier.length")
                                | курьером – {{ aggregated.courier }}
                                span(v-if="deliveriesPvz.length") ;
                            span(v-if="deliveriesPvz.length")  до 
                                a(v-if="settings.pvz_map_shown", href="#", @click.prevent='') 
                                    | пункта самовывоза
                                span(v-if="!settings.pvz_map_shown") пункта самовывоза 
                                |  – {{ aggregated.pvz }}
                    p(style="margin-top: 50px;")
                        i.fa.fa-lightbulb-o(style="color: red;")
                        |  <b> Идея? </b> Пишите на 
                        a(href="mailto:hi@salesbeat.pro") hi@salesbeat.pro
</template>

<script>
import autosize from 'autosize';
import 'prismjs';
import 'prismjs/themes/prism.css';
import PrismEditor from 'vue-prism-editor';

import Page from '@/components/core/Page';
import { formatString, formatIntervalString } from '@/utils/helpers';
import ajaxRequest from '@/utils/request';

export default {
    name: 'WidgetSettings',
    created() {
        this.getDataHook();
    },
    components: {
        Page, PrismEditor
    },
    mounted() {
        // autosize(document.querySelector('.prism-editor__code'))
    },
    methods: {
        getDataHook() {
            this.$store.dispatch('loadWidgetSettings').then(() => {
                this.settings = {...this.$store.state.shops.widgetSettings};

                this.updateAutosize();
                // autosize.update(document.querySelector('textarea'))
            });
        },
        save() {
            this.$store.dispatch('saveWidgetSettings', this.settings);
        },
        discard() {
            this.settings = {...this.$store.state.shops.widgetSettings};
            this.updateAutosize();
        },
        getDeliveryDescription(item, onlyValues = false) {
            let daysString = formatString(item.days, 'days');

            let costString = `${item.cost} руб.`;
            if (!item.cost) {
                costString = 'бесплатно';
            }
            let name = item.name;
            if (this.settings.divide_by_delivery_type) {
                name = name.replace('Самовывоз', '')
                    .replace('Курьерская', '')
                    .replace('курьерская', '')
                    .replace('доставка', '')
                    .trim();
                name = name[0].toUpperCase() + name.slice(1);
            }

            let nameString = (onlyValues || this.settings.delivery_name_shown) ? name + ' ' : '';

            let daysAndCosts = [daysString];
            if (this.settings.delivery_price_shown) {
                daysAndCosts.splice(this.settings.days_first ? 1 : 0, 0, costString);
            }

            return nameString + daysAndCosts.join(', ');
        },
        getAggregatedValues(type) {
            let list;
            if (type === 'pvz') list = this.deliveriesPvz;
            else if (type === 'courier') list = this.deliveriesCourier;
            else throw Error('Not implemented type');

            if (!list.length) return '';
            let minCost = Math.min(...list.map(i => i.cost));
            let maxCost = Math.max(...list.map(i => i.cost));
            let minDays = Math.min(...list.map(i => i.days));
            let maxDays = Math.max(...list.map(i => i.days));

            let costInterval = formatIntervalString(minCost, maxCost, 'rub', this.settings.interval_type);
            if (!maxCost) {
                costInterval = 'бесплатно';
            }
            let daysInterval = formatIntervalString(minDays, maxDays, 'days', this.settings.interval_type);

            let daysAndCosts = [daysInterval];
            if (this.settings.delivery_price_shown) {
                daysAndCosts.splice(this.settings.days_first ? 1 : 0, 0, costInterval);
            }

            return daysAndCosts.join(', ');
        },
        normilize(list) {
            let max = Math.max(...list);
            return list.map(item => item / max);
        },
        createAutosize() {
            this.$nextTick(() => {
                // autosize(document.querySelector('textarea'))
            });
        },
        updateAutosize() {
            this.$nextTick(() => {
                // autosize.update(document.querySelector('textarea'))
            });
        },
        setDefaultStyles() {
            ajaxRequest({
                url: '/widget/get_default_styles/',
                success: ({styles}) => {
                    this.settings.css_styles = styles;
                    this.updateAutosize();
                }
            });
        }
    },
    computed: {
        deliveriesSorted() {
            let sorts = {
                mix: (a, b) => [a.normilizedDays ** 2 + a.normilizedCost ** 2, a.days] >
                                   [b.normilizedDays ** 2 + b.normilizedCost ** 2, b.days],
                days: (a, b) => [a.days, a.cost] > [b.days, b.cost],
                price: (a, b) => [a.cost, a.days] > [b.cost, b.days]
            };
            return this.deliveries.sort(sorts[this.settings.sort]);
        },
        deliveriesPvz() {
            return this.deliveriesSorted.filter(i => i.type === 'pvz');
        },
        deliveriesCourier() {
            return this.deliveriesSorted.filter(i => i.type === 'courier');
        },
        aggregated() {
            return {
                courier: this.getAggregatedValues('courier'),
                pvz: this.getAggregatedValues('pvz')
            };
        },
        settingsChanged() {
            for (let k in this.settings) {
                if (this.settings[k] !== this.$store.state.shops.widgetSettings[k]) return true;
            }
            return false;
        }
    },
    watch: {
        advancedSettingsShown(val) {
            if (val) {
                this.createAutosize();
            }
        }
    },
    data() {
        let deliveries = [{
            days: 1,
            cost: 250,
            name: 'Самовывоз Boxberry',
            type: 'pvz'
        }, {
            days: 2,
            cost: 276,
            name: 'Самовывоз экспресс СПСР',
            type: 'pvz'
        }, {
            days: 2,
            cost: 390,
            name: 'Курьерская доставка B2C',
            type: 'courier'
        }, {
            days: 4,
            cost: 334,
            name: 'СДЭК курьерская доставка',
            type: 'courier'
        }, {
            days: 4,
            cost: 213,
            name: 'Самовывоз СДЭК',
            type: 'pvz'
        }];

        let normilizedDays = this.normilize(deliveries.map(i => i.days));
        let normilizedCosts = this.normilize(deliveries.map(i => i.cost));
        deliveries = deliveries.map((item, i) => {
            item.normilizedDays = normilizedDays[i];
            item.normilizedCost = normilizedCosts[i];
            return item;
        });

        return {
            settings: {},
            advancedSettingsShown: false,

            deliveries
        };
    }
};
</script>

<style>
    * {
        outline-style:none;
    }
    .radio-inline-margins {
        margin-top: 10px!important;
    }
    .radio-inline-margins label {
        margin-bottom: 0px!important;
    }

    .reset-styles ol, .reset-styles ul {
        list-style: none;
    }
    .reset-styles ul, .reset-styles li, .reset-styles p {
        margin: 0;
        padding: 0;
    }
    .reset-styles p {
        margin-bottom: 5px;
    }
    .reset-styles ul {
        margin-bottom: 10px;
    }
    div.prism-editor-wrapper pre {
        margin-top: 30px;
        overflow-y: scroll;
    }
</style>



// WEBPACK FOOTER //
// src/components/WidgetSettings.vue